export default __webpack_public_path__ + "static/media/ncr 2021 icon.1ce7bd5e.svg";